<script setup lang="ts">
// components
import { AppText } from '@UI/Typography/AppText'

defineOptions({
  name: 'BlockFaqCategories',
})

defineProps<{
  categories: string[]
  activeIndex: number
}>()

defineEmits<{
  'click:select': [index: number]
}>()
</script>

<template>
  <nav
    v-if="categories.length"
    class="block-faq-categories"
  >
    <AppText
      tag="p"
      name="h5"
      color="slate-900"
      class="block-faq-categories__title"
    >
      Categories
    </AppText>
    <ul class="block-faq-categories__list">
      <li
        v-for="(category, index) in categories"
        :key="index"
        class="block-faq-categories__item"
        :class="{ 'block-faq-categories__item--active': index === activeIndex }"
      >
        <button
          class="block-faq-categories__button"
          type="button"
          @click="$emit('click:select', index)"
        >
          <AppText
            tag="span"
            :name="index === activeIndex ? 'body2-medium' : 'body2'"
            :color="index === activeIndex ? 'indigo-600' : 'slate-500'"
          >
            {{ category }}
          </AppText>
        </button>
      </li>
    </ul>
  </nav>
</template>

<style scoped lang="scss" src="@scss/components/Blocks/BlockFaqCategories.scss" />
